import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import H3Font from "Root/profile/components/common/H3Font";
import RegFont from "Root/profile/components/common/RegFont";
import chat from "./images/chat.svg";
import clean from "./images/clean.svg";
import protein from "./images/protein.svg";
import science from "./images/science.svg";
import styles from "./styles.module.scss";
export const data = [
    {
        title: "Expert Driven Formulas",
        text: "Clean recipes, formulated by nutrition and fitness experts for maximum effectiveness.",
        image: science,
    },
    {
        title: "Supports Your Personal Goals",
        text: "Customized protein blends that help you meet your goals and make personal gains.",
        image: protein,
    },
    {
        title: "Free Access to Registered Dietitians",
        text: "1:1 access to our R.Ds who will guide & provide you with resources you need to feel and perform your best.",
        image: chat,
    },
    {
        title: "Clean Label Promise",
        text: "We’re committed to clean ingredients -- free from preservatives, artificial flavors, sweeteners or dyes. ",
        image: clean,
    },
];
const OurPromise = () => {
    return (_jsxs("div", { className: styles.ourPromise, children: [_jsx("div", { className: styles.promiseTitle, children: _jsx(H3Font, { children: "Our Promise" }) }), _jsx("div", { className: styles.promiseItems, children: data.map((item) => (_jsxs("div", { className: styles.promiseCard, children: [_jsx("img", { src: item.image, alt: item.title, width: 40, height: 40 }), _jsx(RegFont, { fontWeight: 500, className: styles.cardTitle, children: item.title }), _jsx(RegFont, { className: styles.cardText, children: item.text })] }, item.title))) })] }));
};
export default OurPromise;
